"use client";

import { useEffect } from "react";
import { useRouter } from "next/navigation";
import { api } from "@/lib/api";
import { isAuthenticated, type User } from "@/lib/auth";
import { useAuthStore } from "@/stores/auth-store";

export function useAuth(requireAuth = true) {
  const router = useRouter();
  const { user, isLoading, setUser, setLoading } = useAuthStore();

  useEffect(() => {
    async function loadUser() {
      if (!isAuthenticated()) {
        setLoading(false);
        if (requireAuth) router.push("/login");
        return;
      }
      try {
        const userData = await api.get<User>("/auth/me");
        setUser(userData);
      } catch {
        if (requireAuth) router.push("/login");
      } finally {
        setLoading(false);
      }
    }
    loadUser();
  }, [requireAuth, router, setUser, setLoading]);

  return { user, isLoading };
}
